import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.E_READER;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_ROUND: 'INITIALIZE_ROUND',
  NEXT_STANDARD_ITEM: 'NEXT_STANDARD_ITEM',
  SELECT_RESPONSE: 'SELECT_RESPONSE',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
};

export const SEASON = {
  GRADE_K_1: 1,
  GRADE_2_3: 2,
  GRADE_4_5: 3,
};

export const CHAPTER_ID_REF_PREFIX = 'page';

export const FIRST_CHAPTER_ID_REF = 'page001';
export const TITLE_ID_REF = 'title001';
export const COVER_ID_REF = 'cover001';

export const POST_READING_QUESTION_TYPE = {
  MULTIPLE_CHOICE: 'imageMultipleChoice',
  PLOT_SEQUENCE: 'plotSequence',
  MISSING_IMAGE: 'missingImage',
};

export const CURIOSO_MOOD = {
  HAPPY: 'happy',
  SAD: 'sad',
  IDLE: 'idle',
};

export const RW_AUDIO_TYPES = {
  WORD: 'word',
  DEFINITION: 'definition',
  SYNONYM: 'synonym',
};
